// extracted by mini-css-extract-plugin
export default {"searchFieldContainer":"df0f2559696f","totalText":"a82cef098e2f"};